import React from 'react'

const NoRecordSmall = () => {
  return (
    <p className="text-center ct_no_record_found ct_py_70">
      No record found.
    </p>
  );
}

export default NoRecordSmall
